
import { useState, useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from 'dayjs';
import DownloadIcon from "@mui/icons-material/Download";
import {  Info } from "@mui/icons-material";
import Logocolor from "../../../Image/Logo.png";
import { TituloPrincipal, Texto,  SubTitulodos, buttonCancelar, InputBuscador } from "../../../Layouts/CustomStyles";
import { useGetEstadoResultado } from "../../../Services/FlujodeCaja";
import { formatCLP } from "../../../Components/FuncionesGenerales/FormatoCLP";


const Row = ({ row }) => {
 

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
  title: "",
  descripcion: "",
  fecha: "",
  monto: 0,
  iva: 0,
  usuario: "",
  contact: "",
  sucursal: "",
});



const GananciaOPerdida = row.resultados?.ganancia_perdida_operacional || "0"; 
const ImpuestoRenta = row.resultados?.impuesto_primera_categoria_27 || "0";
const MargenBruto = row.resultados?.margen_bruto || "0";
const ResultadoEjercicio = row.resultados?.resultado_del_ejercicio || "0";
const ResultadoNoOperacional = row.resultados?.resultado_no_operacional || "0";
const ResultadoOperacional = row.resultados?.resultado_operacional || "0";
const UtilidadAntesImpuesto = row.resultados?.utilidad_antes_impuesto || "0";



/* ingresos */
  const IngresoOperacional =
    row.ingresos?.OPERACIONAL?.total_tipo_resultado || 0;
  const ingresosNoOperacionales = row?.ingresos?.NO_OPERACIONAL;
  const DetalleIngresoOperacional =
    row.ingresos?.OPERACIONAL?.categorias || {};


  /* egreso */
  const costosOperacionales = row?.egresos?.COSTO_OPERACIONAL;
  const gastosAdministrativos = row?.egresos?.ADMINISTRATIVO;
  const gastosOperacionales = row?.egresos?.OPERACIONAL;
  const gastosFinancieros = row?.egresos?.GASTO_FINANCIERO;
  const depreciacion = row?.egresos?.DEPRECIACION;
  const gastosNoOperacionales = row?.egresos?.["NO_OPERACIONAL"];
  const gastoGeneral = row?.egresos?.GENERAL;


const handleOpenDialog = (data, tipo, esCategoria = false) => {
  if (esCategoria) {
    setDialogData({
      title: data?.categoria_nombre || "Detalle categoría",
      tipo,
      esCategoria: true,
      items: data?.items || [],
      total: data?.total_categoria || 0
    });
  } else {
    setDialogData({
      title:
        tipo === "INGRESO"
          ? data?.income_type?.name
          : data?.expense_category?.name,
      tipo,
      esCategoria: false,
      fecha: data?.date || data?.created_at || "",
      descripcion: data?.description || "",
      monto: data?.total_amount || data?.amount || 0,
      iva: data?.iva || 0,
      usuario: data?.user?.name || "",
      contact: data?.contact?.name || "",
      sucursal: data?.branch?.name || "",
    });
  }

  setDialogOpen(true);
};

const handleCloseDialog = () => {
    setDialogOpen(false);
  };

 




  return (
    <>
     


     
        <Box sx={{ width: "100%" }}>
          <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Ingreso Operacionales
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                {Object.entries(DetalleIngresoOperacional).map(([nombreCategoria, data]) =>
  data.items.map((ing) => (
                    <TableRow key={ing.id} >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}> {nombreCategoria} </TableCell>
                      
 
                      <TableCell >
                        <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "INGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton>
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>  {formatCLP(data.total_categoria)}</TableCell>
                      
                    </TableRow>
                   ))
)}
                  
                      <TableCell sx={{width:600, fontFamily:'Poppins', fontSize:'0.9rem', fontWeight:600}}>Total ingresos operacionales</TableCell>
                       <TableCell ></TableCell>
                          <TableCell align="right"sx={{fontFamily:'Poppins', fontSize:'0.9rem', fontWeight:600}}>{formatCLP(IngresoOperacional)}</TableCell>
                </TableBody>

       </Table>
              </Box>
              <Box sx={{width:'100%'}}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Costos Operacionales
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {costosOperacionales?.categorias &&
        Object.entries(costosOperacionales.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell
                sx={{
                  width: 600,
                  fontFamily: "Poppins",
                  fontWeight: 500
                }}
              >
                {nombreCategoria}
              </TableCell>

              <TableCell> <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton></TableCell>

              <TableCell
                align="right"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 500
                }}
              >
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* 🔹 TOTAL GENERAL */}
      {costosOperacionales && (
        <TableRow>
          <TableCell
            sx={{
              fontFamily: "Poppins",
              fontSize: "0.95rem",
              fontWeight: 700
            }}
          >
            Total Costos Operacionales
          </TableCell>

          <TableCell> </TableCell>

          <TableCell
            align="right"
            sx={{
              fontFamily: "Poppins",
              fontSize: "0.95rem",
              fontWeight: 700
            }}
          >
            {formatCLP(costosOperacionales.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
               <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
               Utilidad Bruta
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:600}}> Total Utilidad Bruta</TableCell>
 
                      <TableCell >
                        
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:600}}>{formatCLP(MargenBruto)}</TableCell>
                      
                    </TableRow>
               
                      
                </TableBody>

       </Table>
              </Box>
                  <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Gastos de Administración
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {gastosAdministrativos?.categorias &&
        Object.entries(gastosAdministrativos.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell>
                 <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton>
              </TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {gastosAdministrativos && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Gastos de Administración
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(gastosAdministrativos.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
              <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Gastos Operacionales
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {gastosOperacionales?.categorias &&
        Object.entries(gastosOperacionales.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell>  <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton></TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {gastosOperacionales && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Gastos Operacionales
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(gastosOperacionales.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
                 <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Resultado Operacional
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}> Total Resultado Operacional</TableCell>
 
                      <TableCell >
                       
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(ResultadoOperacional)}</TableCell>
                      
                    </TableRow>
                 
                  
                     
                </TableBody>

       </Table>
              </Box>
              <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Gastos Financieros
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {gastosFinancieros?.categorias &&
        Object.entries(gastosFinancieros.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell> <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton></TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {gastosFinancieros && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Gastos Financieros
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(gastosFinancieros.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
               <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Depreciación
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {depreciacion?.categorias &&
        Object.entries(depreciacion.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell> <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton></TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
     {/*  {depreciacion && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Depreciación
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(depreciacion.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )} */}

    </TableBody>
  </Table>
</Box>
                   <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Ganancia o pérdida
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}>total ganancia o pérdida</TableCell>
 
                      <TableCell >
                       
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(GananciaOPerdida)}</TableCell>
                      
                    </TableRow>
                 
                  
                     
                </TableBody>

       </Table>
              </Box>
             <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Ingresos No Operacionales
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {ingresosNoOperacionales?.categorias &&
        Object.entries(ingresosNoOperacionales.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell>
                <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "INGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton>
              </TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {ingresosNoOperacionales && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Ingresos No Operacionales
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(ingresosNoOperacionales.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
             <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Gastos No Operacionales
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {gastosNoOperacionales?.categorias &&
        Object.entries(gastosNoOperacionales.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell>
                <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton>
              </TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {gastosNoOperacionales && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Gastos No Operacionales
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(gastosNoOperacionales.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
    <Box timeout="auto" unmountOnExit sx={{ width: "100%" }}>
  <Box margin={2}>
    <Typography variant="subtitle1" gutterBottom sx={Texto}>
      Gastos Generales
    </Typography>
  </Box>

  <Table size="small" sx={{ marginTop: "-19px" }}>
    <TableBody>

      {gastoGeneral?.categorias &&
        Object.entries(gastoGeneral.categorias).map(
          ([nombreCategoria, data]) => (
            <TableRow key={nombreCategoria}>
              <TableCell sx={{ width: 600, fontFamily: "Poppins", fontWeight: 500 }}>
                {nombreCategoria}
              </TableCell>

              <TableCell>
                <IconButton
                          size="small"
                          sx={{ color: '#1976d2' }}
                           onClick={() => handleOpenDialog(data, "EGRESO", true)}
                        >
                          <Info fontSize="small" />
                        </IconButton>
              </TableCell>

              <TableCell align="right" sx={{ fontFamily: "Poppins", fontWeight: 500 }}>
                {formatCLP(data.total_categoria)}
              </TableCell>
            </TableRow>
          )
        )}

      {/* TOTAL */}
      {gastoGeneral && (
        <TableRow>
          <TableCell sx={{ fontWeight: 700 }}>
            Total Gastos generales
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="right" sx={{ fontWeight: 700 }}>
            {formatCLP(gastoGeneral.total_tipo_resultado)}
          </TableCell>
        </TableRow>
      )}

    </TableBody>
  </Table>
</Box>
               <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Resultado no operacional
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}>total no operacional</TableCell>
 
                      <TableCell >
                      
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(ResultadoNoOperacional)}</TableCell>
                      
                    </TableRow>
                 
                     
                </TableBody>

       </Table>
              </Box>
               <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Resultado Antes del impuesto
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}>total resultado ante impuesto</TableCell>
 
                      <TableCell >
                      
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(UtilidadAntesImpuesto)}</TableCell>
                      
                    </TableRow>
                 
                     
                </TableBody>

       </Table>
              </Box>
                <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Utilidad o perdida antes de impuestos
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:600, fontFamily:'Poppins', fontWeight:500}}>Impuestos</TableCell>
 
                      <TableCell >
                       
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(ImpuestoRenta)}</TableCell>
                     </TableRow>
                 
                  
                     
                </TableBody>

       </Table>
              </Box>
                  
                   <Box sx={{width:'100%'}}>
            <Box margin={2}>
              <Typography variant="subtitle1" gutterBottom sx={Texto}>
                Resultado Estado Resultado
              </Typography>
               <Typography variant="subtitle2"  sx={Texto}>
                Detalle
              </Typography>
              </Box>
                <Table size="small" sx={{marginTop:'-19px'}}>
                <TableBody>
                 
                    <TableRow  >
                      <TableCell  sx={{width:800, fontFamily:'Poppins', fontWeight:500}}>Total Ganancia o perdida </TableCell>
 
                      <TableCell >
                       
                      </TableCell>
                      <TableCell align="right" sx={{fontFamily:'Poppins', fontWeight:500}}>{formatCLP(ResultadoEjercicio)}</TableCell>
                       
                      
                    </TableRow>
                 
                  
                     
                </TableBody>

       </Table>
              </Box>
              
              </Box>
   
      

       
      
       
  
   
     

      {/* DIALOG */}
    <Dialog
  open={dialogOpen}
  onClose={handleCloseDialog}
  fullWidth
  maxWidth="xl"
>
  <DialogTitle sx={TituloPrincipal}>
    {dialogData.title}
  </DialogTitle>

  <DialogContent dividers>
  

    {dialogData.esCategoria && (
  <>
  <Box
      sx={{
        display: "flex",
        mb: 1,
        borderBottom: "1px solid #eee",
        pb: 1
      }}
    >
      <Typography sx={{ ...SubTitulodos, flex: 1 }}>Fecha</Typography>
      <Typography sx={{ ...SubTitulodos, flex: 1 }}>Sucursal</Typography>
      <Typography sx={{ ...SubTitulodos, flex: 1 }}>Tipo</Typography>
      <Typography sx={{ ...SubTitulodos, flex: 1 }}>Categoría</Typography>
      <Typography sx={{ ...SubTitulodos, flex: 1 }}>Descripción</Typography>
      <Typography sx={{ ...SubTitulodos, flex: 1, textAlign: "right" }}>
        Monto
      </Typography>
      <Typography
        sx={{
          ...SubTitulodos,
          flex: 1,
          textAlign: "center",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <span>Cuotas</span>
        <span>restantes</span>
      </Typography>
    </Box>
    {dialogData.items.map((item, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 1,
          borderBottom: "1px solid #eee",
          pb: 1
        }}
      >
        <Typography sx={{ ...SubTitulodos, flex: 1 }}>
        {item.fecha || item.date
  ? dayjs(item.fecha || item.date).format("DD-MM-YYYY")
  : "-"}
        </Typography>
        <Typography sx={{ ...SubTitulodos, flex: 1 }}>
          {item.sucursal || item.branch.name}
        </Typography>

        <Typography sx={{ ...SubTitulodos, flex: 1 }}>
          {item.categoria_nombre  || "-"}
        </Typography>

        <Typography sx={{ ...SubTitulodos, flex: 1 }}>
          {item.categoria_oficial || item.income_type?.name}
        </Typography>
        <Typography sx={{ ...SubTitulodos, flex: 1 }}>
          {item.descripcion || item.concept}
        </Typography>

        <Typography sx={{ ...SubTitulodos, flex: 1, textAlign: "right" }}>
          {formatCLP(item.total_amount || item.monto)}
        </Typography>

        <Typography sx={{ ...SubTitulodos, flex: 1, textAlign: "center" }}>
          {item.cuotas || "-"}
        </Typography>
      </Box>
    ))}

    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
        fontWeight: 700
      }}
    >
      <Typography sx={SubTitulodos}>Total</Typography>
      <Typography sx={SubTitulodos}>{formatCLP(dialogData.total)}</Typography>
    </Box>
  </>
)}
{!dialogData.esCategoria && (
  <>
    <Typography sx={SubTitulodos}>
      <strong>Fecha:</strong>{" "}
      {dialogData.fecha
        ? dayjs(dialogData.fecha).format("DD-MM-YYYY")
        : "-"}
    </Typography>

    <Typography sx={SubTitulodos}>
      <strong>Descripción:</strong>{" "}
      {dialogData.descripcion || "Sin descripción"}
    </Typography>

    <Typography sx={SubTitulodos}>
      <strong>Monto:</strong>{" "}
      {formatCLP(dialogData.monto)}
    </Typography>

    {dialogData.iva > 0 && (
      <Typography sx={SubTitulodos}>
        <strong>IVA:</strong>{" "}
        {formatCLP(dialogData.iva)}
      </Typography>
    )}

    {dialogData.usuario && (
      <Typography sx={SubTitulodos}>
        <strong>Usuario:</strong>{" "}
        {dialogData.usuario}
      </Typography>
    )}

    {dialogData.contact && (
      <Typography sx={SubTitulodos}>
        <strong>Contacto:</strong>{" "}
        {dialogData.contact}
      </Typography>
    )}

    {dialogData.sucursal && (
      <Typography sx={SubTitulodos}>
        <strong>Sucursal:</strong>{" "}
        {dialogData.sucursal}
      </Typography>
    )}
  </>
)}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={handleCloseDialog}
      sx={buttonCancelar}
    >
      Cerrar
    </Button>
  </DialogActions>
</Dialog>


    </>
  );
};



export const EstadoResultado = () => {
   const { estadoResultado, loadingEstadoResultado, errorEstadoResultado, exportarEstadoResultado } = useGetEstadoResultado();
 const [fechaInicio, setFechaInicio] = useState(estadoResultado?.[0]?.fecha || "");
const [fechaFin, setFechaFin] = useState(estadoResultado?.[estadoResultado.length-1]?.fecha || "");
  const [periodosVisibles, setPeriodosVisibles] = useState([]);

  useEffect(() => {
    if (!estadoResultado?.length) return;

    const periodosOrdenados = [...estadoResultado].reverse(); // más recientes primero
    let visibles = [];

    if (!fechaInicio && !fechaFin) {
      visibles = periodosOrdenados.slice(0, 3);
    } else {
      const filtrados = periodosOrdenados.filter((p) => {
        const fechaPeriodo = new Date(p.fecha); // usar la fecha en formato YYYY-MM-01
        const desde = fechaInicio ? new Date(fechaInicio) : null;
        const hasta = fechaFin ? new Date(fechaFin) : null;

        if (desde && hasta) return fechaPeriodo >= desde && fechaPeriodo <= hasta;
        if (desde) return fechaPeriodo >= desde;
        if (hasta) return fechaPeriodo <= hasta;
        return true;
      });
      visibles = filtrados.slice(0, 3);
    }

    setPeriodosVisibles(visibles.reverse()); // volver a orden cronológico
  }, [estadoResultado, fechaInicio, fechaFin]);

  // 🔹 Para selects "Hasta" dinámico
  const periodosHasta = fechaInicio
  ? estadoResultado.filter((p) => new Date(p.fecha) >= new Date(fechaInicio))
  : estadoResultado;


    if (loadingEstadoResultado) {
        return (
             <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "300px",
                  gap: 2,
                  position: "relative"
                }}
              >
                {/* Círculo */}
                <CircularProgress size={90} thickness={4} sx={{ color: '#6fd385ff' }} />
    
                {/* Imagen centrada encima del círculo */}
                <Box
                  component="img"
                  src={Logocolor}
                  alt="Logo"
                  sx={{
                    width: "55px",
                    height: "55px",
                    position: "absolute",
                    top: "90px"
                  }}
                />
    
                <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
                  Cargando...
                </Typography>
              </Box>
        );
      }
                 if (errorEstadoResultado) {
    return (
      <Typography color="error" sx={{ textAlign: "center", mt: 4 }}>
        {errorEstadoResultado}
      </Typography>
    );
  }

    return(
         <Container maxWidth="lg">
      <Paper
        elevation={6}
        sx={{
          p: 7,
          borderRadius: "16px",
          backgroundColor: "#fafafa",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          fontFamily: "Poppins",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <img src={Logocolor} alt="Logo CBO" style={{ width: 55, height: 55 }} />
                    <Typography variant="h5" sx={TituloPrincipal}>
                      Estado Resultado RME
                    </Typography>
                  </Box>
                  </Box>
       
        {/* Filtros */}
                  <Box display="flex" justifyContent="flex-end" gap={2} mb={3}>
          <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
            <InputLabel id="select-periodo-desde">Desde</InputLabel>
            <Select
              labelId="select-periodo-desde"
              value={fechaInicio}
              label="Desde"
              onChange={(e) => setFechaInicio(e.target.value)}

            >
              {estadoResultado.map((p, idx) => (
               <MenuItem key={idx} value={p.fecha}>{p.mes}</MenuItem>

              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
            <InputLabel id="select-periodo-hasta">Hasta</InputLabel>
            <Select
              labelId="select-periodo-hasta"
              value={fechaFin}
              label="Hasta"
              onChange={(e) => setFechaFin(e.target.value)}
            >
              {periodosHasta.map((p, idx) => (
                <MenuItem key={idx} value={p.fecha}>{p.mes}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            sx={{ color: '#fff', padding: '5px 20px', backgroundColor: "#2a8d74", borderRadius: "50px", textTransform: "none", fontFamily: "Poppins" }}
            onClick={() => { setFechaInicio(""); setFechaFin(""); }}
          >
            Limpiar
          </Button>
        </Box>
        
        <Box sx={{mb:2}}>
        <Button
  sx={{
    color: "#fff",
    padding: "5px 20px",
    backgroundColor: "#2a8d74",
    borderRadius: "50px",
    textTransform: "none",
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    gap: 1, // espacio entre icono y texto
  }}
   onClick={() =>
    exportarEstadoResultado(
      periodosVisibles.map((p) => p.fecha)
    )
  }
>
  <DownloadIcon sx={{ fontSize: 20 }} />
  Descargar Estado Resultado
</Button>
</Box>

       <Box display="flex" flexDirection="column" gap={2}>
  {periodosVisibles
    .slice()
    .reverse()
    .map((mes) => (
      <Accordion
        key={mes.mes}
        sx={{
          borderRadius: 3,
          boxShadow: 2,
          "&:before": { display: "none" }
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: "Poppins",
              fontSize: "16px"
            }}
          >
            {mes.mes}
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Row row={mes} />
        </AccordionDetails>
      </Accordion>
    ))}
</Box>
      </Paper>
    </Container>
  );
};